























import Vue from "vue";
import Component from "vue-class-component";
import ManageGruposDialog from "../dialogs/ManageGruposDialog.vue"


@Component({
  components: {
    ManageGruposDialog
  },
})
export default class GrupoMenu extends Vue {}
